import { render, staticRenderFns } from "./HelpCenterMenuItem.vue?vue&type=template&id=3606d2ec&"
import script from "./HelpCenterMenuItem.vue?vue&type=script&lang=js&"
export * from "./HelpCenterMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports